import React from 'react';

const ChevronRightIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.87514 2.42383L7.53805 3.08674L13.5671 9.11577C14.0553 9.60393 14.0553 10.3954 13.5671 10.8835L7.53805 16.9125L6.87514 17.5755L5.54932 16.2497L6.21223 15.5868L11.7993 9.99965L6.21223 4.41257L5.54932 3.74965L6.87514 2.42383Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronRightIcon;
